import React from 'react'
import styled from 'styled-components'

import { ClinTheme } from '../../ClinTheme'
import { mediaQuery } from '../../utils/mediaQuery'

export interface IClinDropdownMenuStyles
  extends React.HTMLAttributes<HTMLDivElement> {
  /** Define the top margin for an offset */
  marginTop?: string | number
}

export const StyledClinDropdownMenu = styled.div<IClinDropdownMenuStyles>(
  {
    display: 'inline-block',
    [mediaQuery(ClinTheme.breakpoints[3])]: {
      padding: ClinTheme.space[3],
      backgroundColor: ClinTheme.colors.white,
      borderRadius: ClinTheme.radii[1],
      boxShadow: ClinTheme.shadows[0]
    }
  },
  ({ marginTop = 0 }: IClinDropdownMenuStyles) => ({
    marginTop
  })
)
